import React, { useState } from "react";
import { withTranslation } from "react-i18next";
import TabbedContainer from "../App/components/common/TabbedContainer";
import MarketDataDashboard from "./marketData/marketDataDashboard";
import HistoricalMarketDataHeader from "./historicalMarketData/historicalMarketDataHeader";
import HistoricalTradeDataHeader from "./historicalTradeData/historicalTradeDataHeader";
import IndexDataHeader from "./indexData/indexDataHeader";
import { usePermitted } from "../common/components/permissions/permissions";

const MarketData = ({ market, venue, termSchedules, productId, t }) => {
  const [activeTab, setActiveTab] = useState("dailySummary");
  const canViewIndexData = usePermitted(["administrator"]); //Temporary, until we finalize how this is to be deployed.

  const tabs = [
    {
      id: "dailySummary",
      label: t("DailySummary"),
      icon: "fa fa-chart-column",
      content: (
        <MarketDataDashboard
          market={market}
          venue={venue}
          termSchedules={termSchedules}
        />
      ),
    },
    {
      id: "historicalPrices",
      label: t("HistoricalMarketData"),
      icon: "fa fa-chart-line",
      content: (
        <HistoricalMarketDataHeader market={market} productId={productId} />
      ),
    },
    {
      id: "historicalTrades",
      label: t("HistoricalTrades"),
      icon: "fa fa-arrow-right-arrow-left",
      content: (
        <HistoricalTradeDataHeader market={market} productId={productId} />
      ),
    },
    ...(canViewIndexData
      ? [
          {
            id: "indexData",
            label: t("IndexData"),
            icon: "fa fa-magnifying-glass-chart",
            content: <IndexDataHeader market={market} productId={productId} />,
          },
        ]
      : []),
  ];

  return (
    <TabbedContainer
      activeTab={activeTab}
      onTabChange={setActiveTab}
      tabs={tabs}
    />
  );
};

export default withTranslation()(MarketData);
